// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyAPrfeKX7EUzt8rwpjuTCHWbjOmgDdgIFM',
  authDomain: 'test-b9bc1.firebaseapp.com',
  projectId: 'test-b9bc1',
  storageBucket: 'test-b9bc1.firebasestorage.app',
  messagingSenderId: '997884629602',
  appId: '1:997884629602:web:53365be02afa62b670373b',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
import { getStorage } from 'firebase/storage';

const storage = getStorage(app);

export { storage };
